module.exports = "<div>\n  <div v-show=\"!loading && !results.length\" class=\"bfv-infothek-neuigkeiten__error\">\n    Das Laden der Daten ist leider fehlgeschlagen.\n  </div>\n\n  <div v-if=\"nextResults\">\n    <button\n      class=\"btn bfv-scorer-table__load-button js-load-button   \"\n      name=\"\"\n      type=\"button\" \n      \n      \n      \n      \n      v-on:click=\"loadMore\" \n    >\n    \n    \n        <div class=\"btn__text\">\n          Mehr laden\n        </div>\n    </button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/templates/partials/organisms/MD130_Torschuetzenliste/vue-load-more-template.hbs
// module id = 693
// module chunks = 0